import { Outlet, redirect } from "react-router";
import { getDeviceToken } from "~/lib/device-session";
import { SyncProvider } from "~/providers/sync-provider";

export function clientLoader() {
	if (!getDeviceToken()) {
		throw redirect("/provision");
	}
	return null;
}
clientLoader.hydrate = true as const;

export function HydrateFallback() {
	return <main className="min-h-dvh bg-slate-950" />;
}

export default function OperatorLayout() {
	return (
		<SyncProvider>
			<Outlet />
		</SyncProvider>
	);
}
